var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSpacingStandard = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "23px",
  height: "23px",
  viewBox: "0 0 23 23",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.000000, 4.000000)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 19,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 12,
  width: 19,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 6,
  width: 19,
  height: 3,
  rx: 1
})))));
export default SvgSpacingStandard;